/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import * as MsDyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';
import { IMfrmFooterCustomerServiceBlockData } from './mfrm-footer-customer-service-block.data';
import { IMfrmFooterCustomerServiceBlockProps } from './mfrm-footer-customer-service-block.props.autogenerated';

export interface IMfrmFooterCustomerServiceBlockViewProps
    extends IMfrmFooterCustomerServiceBlockProps<IMfrmFooterCustomerServiceBlockData> {
    paragraph: MsDyn365.RichText;
    phoneNumber: string;
    className: string;
}

/**
 *
 * MfrmFooterCustomerServiceBlock component
 * @extends {React.PureComponent<IMfrmFooterCustomerServiceBlockProps<IMfrmFooterCustomerServiceBlockData>>}
 */
class MfrmFooterCustomerServiceBlock extends React.PureComponent<
    IMfrmFooterCustomerServiceBlockProps<IMfrmFooterCustomerServiceBlockData>
    > {
    public render(): JSX.Element | null {
        const { paragraph, className, phoneNumber } = this.props.config;

        const text = paragraph && (
            <MsDyn365.RichTextComponent
                text={paragraph}
                editProps={{ onEdit: this.handleTextChange, requestContext: this.props.context.request }}
            />
        );

        const footerPhoneNumber = phoneNumber &&
        (
            <a
                className='phone-number'
                href={`tel:${phoneNumber.replace(/\D/g, '')}`}
                // tslint:disable-next-line: jsx-no-lambda react-this-binding-issue
                onClick={() => {
                    // @ts-ignore
                    if (utag) {
                        // @ts-ignore
                        // tslint:disable-next-line: object-literal-key-quotes
                        utag.link({ 'event': 'call-engagement', 'event_type': 'call_engagement', 'event_category': 'call', 'event_action': 'footer click', 'event_label': 'call engagement', 'event_noninteraction': 'false' });
                    }
                }}
            >
                {phoneNumber}
            </a>
        );

        const mfrmfooterCustomerServiceBlockProps = {
            ...this.props,
            paragraph: text,
            phoneNumber: footerPhoneNumber,
            className: classnames('ms-text-block', className)
        };
        return this.props.renderView(mfrmfooterCustomerServiceBlockProps);
    }

    public handleTextChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.paragraph = event.target.value);
}

export default MfrmFooterCustomerServiceBlock;
